import { CookieUtils } from './cookie-utils'
import { STORAGE_KEYS } from './auth-constants'

export class AuthToken {
  static get() {
    return CookieUtils.get(STORAGE_KEYS.TOKEN)
  }
}
